import React from 'react';
import './Audit.css';

const Audit = ({ auditEntries = [] }) => {
  return (
    <div className="sa-card">
      <div className="sa-card-header">
        <h2>Audit Log</h2>
        <div className="sa-actions">
          <button className="sa-btn ghost" disabled>
            Export
          </button>
        </div>
      </div>
      <div className="sa-list">
        {auditEntries.map((a, i) => (
          <div className="sa-list-row" key={i}>
            <div>
              <p className="sa-list-title">{a.action}</p>
              <p className="sa-list-subtitle">{a.who}</p>
            </div>
            <span className="sa-list-time">{a.when}</span>
          </div>
        ))}
        {auditEntries.length === 0 && <div className="sa-empty">No audit entries yet.</div>}
      </div>
    </div>
  );
};

export default Audit;
